import ReactPlayer from 'react-player';
import { ReactPlayerProps } from 'react-player/dist/types';

export const LazyReactPlayer = ({
  width = '100%',
  height = '100%',
  url,
  ...rest
}: ReactPlayerProps & { url?: string }) => {
  return <ReactPlayer src={url} style={{ width, height }} {...rest} />;
};
